<template>
  <v-dialog v-model="showModal" width="500" persistent>
      <v-card>
        <v-card-title class="headline">Delete contact</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h5 class="mb-3">
            <strong>Are you sure to eliminate the contact?</strong> 
          </h5>
          <p>
            Name: <strong> {{ contact.name }}</strong> <br>
            Email: <strong> {{ contact.email }}</strong>
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModalDeleteContact">No</v-btn>
          <v-btn color="primary" @click="destroyContact">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    contact: {
      type: Object
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    destroyContact () {
      let url = `/contacts/${this.contact.id}`;
      this.setLoading(false);
      window.axios.delete(url).then((response) => {
        this.setLoading(false);
        this.setSnackbar({
          show: true,
          color: 'success',
          text: 'Contact deleted Successfully!'
        });

        this.$emit('delete-contact');
        this.closeModalDeleteContact();
      }).catch((error) => {
        this.setLoading(false);
        this.setSnackbar({
          show: true,
          color: 'red',
          text: 'Error delete Contact!'
        });
      });  
    },
    closeModalDeleteContact () {
      this.$emit('close-modal-delete-contact');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/contacts/components/modals/DeleteContact.vue